import BarcBanner from 'components/molecules/BarcBanner/BarcBanner';
import MoreSurveysBanner from 'components/molecules/MoreSurveysBanner/MoreSurveysBanner';
import NoSurveys from 'components/molecules/NoSurveys/NoSurveys';
import BarcModal from 'components/organisms/BarcModal/BarcModal';
import BarcSavedModal from 'components/organisms/BarcModal/BarcSavedModal';
import DashboardToolbar, {
  DashboardToolbarOptions,
} from 'components/organisms/DashboardToolbar/DashboardToolbar';
import RedeemBanner from 'components/organisms/RedeemBanner/RedeemBanner';
import SurveyList from 'components/organisms/SurveyList/SurveyList';
import useShowAdmin from 'hooks/useShowAdmin';
import React, { Suspense, useState } from 'react';
import { graphql, useLazyLoadQuery } from 'react-relay';
import { DashboardQuery } from './__generated__/DashboardQuery.graphql';
import classes from './Dashboard.module.scss';

export interface Props {}

const query = graphql`
  query DashboardQuery($input: FilteredSurveyInput!, $barcCookieModalOpen: Boolean!) {
    walletBalance {
      ...RedeemBanner_balance
    }
    targetRedemptionValue {
      ...RedeemBanner_target
    }
    surveys(input: $input) {
      pageInfo {
        totalCount
      }
    }
    ...SurveyListFragment_surveysRef @arguments(input: $input)
    ...MoreSurveysBanner_profileUrlRef
    ...BarcModal_cookiesRef @include(if: $barcCookieModalOpen)
  }
`;

const Dashboard: React.FC<Props> = () => {
  const [surveyFilter, setSurveyFilter] = useState<DashboardToolbarOptions>(
    DashboardToolbarOptions.AllSurveys,
  );
  const [barcCookieModalOpen, setBarcCookieModalOpen] = useState(false);
  const [barcCookieModalSaved, setBarcCookieModalSaved] = useState(false);
  const showAdminSurveys = useShowAdmin();

  const data = useLazyLoadQuery<DashboardQuery>(
    query,
    {
      input: {
        PIISurveys: true,
        webcamSurveys: true,
        trackingParams: showAdminSurveys ? [{ key: 'am', value: 'true' }] : [],
      },
      barcCookieModalOpen,
    },
    {
      fetchPolicy: 'store-or-network',
    },
  );

  return (
    <>
      {data.surveys?.pageInfo.totalCount ? (
        <div className={classes.root}>
          <section>
            <DashboardToolbar
              filter={surveyFilter}
              onChanged={setSurveyFilter}
              className={classes.toolbar}
            />
            {data.walletBalance && data.targetRedemptionValue && (
              <RedeemBanner
                balanceRef={data.walletBalance}
                targetRef={data.targetRedemptionValue}
                className={classes.redeemBanner}
              />
            )}
            <div className={classes.bannerContainer}>
              <MoreSurveysBanner profileUrlRef={data} className={classes.moreSurveysBanner} />
              <Suspense>
                <BarcBanner
                  className={classes.barcBanner}
                  onClick={() => setBarcCookieModalOpen(true)}
                />
              </Suspense>
            </div>
            <SurveyList
              onFiltersChanged={setSurveyFilter}
              surveyFilter={surveyFilter}
              surveysRef={data}
            />
          </section>
        </div>
      ) : (
        <NoSurveys />
      )}
      {barcCookieModalOpen && (
        <Suspense>
          <BarcModal
            onClose={() => setBarcCookieModalOpen(false)}
            onSave={() => {
              setBarcCookieModalOpen(false);
              setBarcCookieModalSaved(true);
            }}
            cookiesRef={data}
          />
        </Suspense>
      )}
      {barcCookieModalSaved && <BarcSavedModal onClose={() => setBarcCookieModalSaved(false)} />}
    </>
  );
};

export default Dashboard;
